import React, { useMemo } from 'react'
import useRedtailMetricPreset from '../../ComponentBlueprint/renderers/redtailMetric/useRedtailMetricPreset'
import { useDailyGreetingShared } from './useDailyGreetingShared'
import { resolveTasksMetricConfig } from './resolveTasksMetricConfig'
import { buildSubtitle } from './buildSubtitle'
import DailyGreetingShell from './DailyGreetingShell'
import { dailyGreetingRedtailStandardPropTypes } from './dailyGreetingPropTypes'

function DailyGreetingRedtailStandard ({
  userName,
  meetingsLinkTo: _meetingsLinkTo,
  tasksLinkTo: _tasksLinkTo,
  overdueStartDate,
  tasksLinkMode: _tasksLinkMode,
  blueprintCode,
  tasksPresentationKey,
  blueprint,
  isLoadingBlueprint
}) {
  const shared = useDailyGreetingShared({
    userName,
    rawOverdueStartDate: overdueStartDate,
    skipWealthJourneyMeetings: false
  })
  const {
    classes,
    meetingsRemainingCount,
    isLoadingMeetings,
    tasksDueTodayCount,
    isLoadingDueToday,
    greetingText
  } = shared

  const metricConfig = useMemo(
    () =>
      resolveTasksMetricConfig({
        blueprintCode,
        tasksPresentationKey,
        blueprint,
        isLoadingBlueprint
      }),
    [blueprintCode, tasksPresentationKey, blueprint, isLoadingBlueprint]
  )

  const isBlueprintPendingForMetric = Boolean(
    blueprintCode && tasksPresentationKey && isLoadingBlueprint
  )

  const { value, isLoading: isLoadingOverdueRaw, notLinked } = useRedtailMetricPreset(
    'past-due-tasks',
    metricConfig
  )

  const isLoadingOverdue = isLoadingOverdueRaw || isBlueprintPendingForMetric
  const overdueCountForSubtitle = isBlueprintPendingForMetric ? 0 : (value != null ? value : 0)
  const includeOverduePhrase = !notLinked

  const subtitleNode = useMemo(
    () =>
      buildSubtitle({
        classes,
        meetingsRemainingCount,
        isLoadingMeetings,
        tasksDueTodayCount,
        isLoadingDueToday,
        overdueCount: overdueCountForSubtitle,
        isLoadingOverdue,
        includeOverdue: includeOverduePhrase,
        meetingsCopyVariant: 'today',
        allCaughtUpCopyVariant: 'default'
      }),
    [
      classes,
      meetingsRemainingCount,
      isLoadingMeetings,
      tasksDueTodayCount,
      isLoadingDueToday,
      overdueCountForSubtitle,
      isLoadingOverdue,
      includeOverduePhrase
    ]
  )

  return (
    <DailyGreetingShell
      classes={classes}
      greetingText={greetingText}
      subtitleNode={subtitleNode}
    />
  )
}

DailyGreetingRedtailStandard.propTypes = dailyGreetingRedtailStandardPropTypes

export default DailyGreetingRedtailStandard
